<template>
	<div>
		<setIm></setIm>
		<div style="position: absolute; top: 20px; right: 10px; z-index: 9; display: flex; align-items: flex-start;">
			<receptionStatus style="margin: 5px 15px 0 0;"></receptionStatus>
			<robotSelect style="margin-right: 10px" :shopId="$store.state.currentShop.id"></robotSelect>
			<imStatus @closeSession="closeSession"></imStatus>
		</div>
		<shopList></shopList>
	</div>
</template>

<script>
import setIm from './setIm.vue'
import imStatus from './imStatus.vue'
import shopList from './shopList.vue'
import receptionStatus from './receptionStatus.vue'
import robotSelect from '../../components/robotSelect.vue'
export default {
	name: 'headTpl',
	data () {
		return {}
	},
	components: {
		'setIm': setIm,
		'imStatus': imStatus,
		'shopList': shopList,
		'robotSelect': robotSelect,
		'receptionStatus': receptionStatus
	},
	methods: {
		// 关闭会话
		closeSession (sessionId) {
			var self = this;

			self.$emit('closeSession', sessionId);
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/pages/head/headTpl.vue